import { useState } from 'react';
import { useAdmin } from '../context/AdminContext';
import { quickAuthCheck } from '../services/unifiedAuthService';

export const useAuthCheck = () => {
  const { isAuthorized } = useAdmin();
  const [showAuthModal, setShowAuthModal] = useState(false);

  const checkAuth = async (action = "access this feature") => {
    // If already authorized, allow the action
    if (isAuthorized) {
      return true;
    }

    // Check authorization status from server (uses cache for performance)
    try {
      const authData = await quickAuthCheck();
      if (authData.is_authorized) {
        // Update local storage and allow action
        localStorage.setItem('isUserAuthorized', 'true');
        sessionStorage.setItem('wasAuthorized', 'true');
        return true;
      }
    } catch (error) {
      // Quietly handle auth check failures
    }

    // Not authorized - show modal
    setShowAuthModal(true);
    return false;
  };

  const closeAuthModal = () => {
    setShowAuthModal(false);
  };

  return {
    checkAuth,
    showAuthModal,
    closeAuthModal,
    isAuthorized
  };
};